import React from 'react';
import { TextQuestion } from './TextQuestion';
import { UniqueSelectQuestion } from './UniqueSelectQuestion';
import { MultiSelectQuestion } from './MultiSelectQuestion';
import { IQuestionComponentDict, IQuestionProps } from 'pages/forms/hooks/useAnswerManager/types';
import { NumericQuestion } from './NumericQuestion';

const QuestionComponent: IQuestionComponentDict = {
  MULTIPLE_SELECT: MultiSelectQuestion,
  UNIQUE_SELECT: UniqueSelectQuestion,
  TEXT: TextQuestion,
  NUMERIC: NumericQuestion
};

export const RenderQuestion = ({ question, handleChangeAnswer, disableInput }: IQuestionProps) => {
  const Component = QuestionComponent[question.type];

  return <Component question={question} handleChangeAnswer={handleChangeAnswer} disableInput={disableInput} />;
};
